import { createApiRef } from '@backstage/core-plugin-api';
import { TestEquipmentsClient } from './TestEquipmentsClient';

export const testEquipmentsApiRef = createApiRef<TestEquipmentsClient>({
  id: 'plugin.test-equipments.service',
});

export { ProtectedStateError, TestEquipmentsClient } from './TestEquipmentsClient';
export type * from './types';
